var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.16475 5.17972C2.94508 5.41935 2.94508 5.80787 3.16475 6.0475L7.53989 10.8203C7.66561 10.9574 7.83603 11.0161 7.99999 10.9962C8.16395 11.0161 8.33438 10.9574 8.4601 10.8203L12.8352 6.0475C13.0549 5.80787 13.0549 5.41935 12.8352 5.17972C12.6156 4.94009 12.2594 4.94009 12.0398 5.17972L7.99999 9.58664L3.96023 5.17972C3.74056 4.94009 3.38441 4.94009 3.16475 5.17972Z","fill":"#C8C8C8"}));
}

ArrowDownInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
